// extracted by mini-css-extract-plugin
export default {"CheckboxWrap":"index_CheckboxWrap__pD-zN","Checkbox":"index_Checkbox__OOT0T"};